<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    console.log('走了00')
        this.getnewsType();
        this.getpolicyType();
        this.getenType();
        this.getnqiType();
        this.getData();
    //   window.addEventListener('beforeunload',()=>{
    //   if (localStorage.getItem("liftConcat")) {
    //     localStorage.removeItem("liftConcat");
    //   }
    //   if (localStorage.getItem("materialForm")) {
    //     localStorage.removeItem("materialForm");
    //   }
    // });

  },
  methods: {
    // 新闻分类所有
    async getnewsType() {
      let res = await this.$request.get('/v1/pc/newsClass/all');
      // this.newsList = res.data;
      this.$store.commit('NEWSLIST',res.data);
      localStorage.setItem('newsList', JSON.stringify(res.data))
      
    },
    // 政策分类
    async getpolicyType() {
      let res = await this.$request.get('/v1/pc/policyClass/all');
      // this.policyList = res.data;
      this.$store.commit('POLICYLIST',res.data);
      localStorage.setItem('policyList', JSON.stringify(res.data))
    },
    // nqi
    async getnqiType() {
      let res = await this.$request.get('/v1/pc/nqiClass/all');
      // this.nqiList = res.data;
      this.$store.commit('NQILIST',res.data);
      localStorage.setItem('nqiList', JSON.stringify(res.data))
    },
    // 企业名录
    async getenType() {
      let res = await this.$request.get('/v1/pc/enterpriseClassAll/index');
      // this.enterList = res.data;
      this.$store.commit('ENTERLIST',res.data);
      localStorage.setItem('enterList', JSON.stringify(res.data))
    },
    // 数据字典
    async getData() {
        let res = await this.$request.get('/v1/pc/setting/index');
        this.$store.commit('DATESOURCE',res.data);
        localStorage.setItem('bigLogo', JSON.stringify(res.data[2].value))
        localStorage.setItem('smallLogo', JSON.stringify(res.data[3].value))
        localStorage.setItem('videoTitle', JSON.stringify(res.data[10].value))
        localStorage.setItem('video', JSON.stringify(res.data[11].value))
    },
  }
}
// export default {
// 	name: 'App',
// 	data() {
// 		return {
// 			clientWidth: 1920
// 		};
// 	},

// 	// components:{StreetShopList},
// 	mounted() {
// 		// 记录一开始的屏幕宽度
// 		this.handleSize();
// 		window.addEventListener('resize', () => {
// 			this.handleSize();
// 		});
// 	},
// 	methods: {
// 		handleSize() {
// 			let docEl = document.documentElement;
// 			let clientWidth = docEl.clientWidth;

// 			if (!clientWidth) return;
// 			docEl.style.fontSize = 1 * (clientWidth / 1920) + 'px';
// 		}
// 	}
// };
</script>

<style>
@import url("@/styles/common.css");
</style>
